// Generated by purs version 0.13.5
"use strict";
var Control_Bind = require("../Control.Bind/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Int = require("../Data.Int/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_String_CodePoints = require("../Data.String.CodePoints/index.js");
var Effect = require("../Effect/index.js");
var React_Basic = require("../React.Basic/index.js");
var React_Basic_DOM = require("../React.Basic.DOM/index.js");
var React_Basic_DOM_Events = require("../React.Basic.DOM.Events/index.js");
var React_Basic_DOM_Generated = require("../React.Basic.DOM.Generated/index.js");
var React_Basic_Events = require("../React.Basic.Events/index.js");
var Web_DOM_Element = require("../Web.DOM.Element/index.js");
var Web_DOM_NonElementParentNode = require("../Web.DOM.NonElementParentNode/index.js");
var Web_HTML = require("../Web.HTML/index.js");
var Web_HTML_HTMLDocument = require("../Web.HTML.HTMLDocument/index.js");
var Web_HTML_Window = require("../Web.HTML.Window/index.js");
var component = React_Basic.createComponent("ZoomSlider");
var zoomSlider = (function () {
    var xxx = function (self) {
        return function __do() {
            var v = Control_Bind.bindFlipped(Effect.bindEffect)(Web_DOM_NonElementParentNode.getElementById("slider"))(Data_Functor.map(Effect.functorEffect)(Web_HTML_HTMLDocument.toNonElementParentNode)(Control_Bind.bindFlipped(Effect.bindEffect)(Web_HTML_Window.document)(Web_HTML.window)))();
            var slider$prime = Data_Maybe.fromJust()(v);
            var v1 = Web_DOM_Element.clientWidth(slider$prime)();
            var value = Data_Int.toNumber(self.props.value);
            var min = Data_Int.toNumber(self.props.min);
            var max = Data_Int.toNumber(self.props.max);
            var p = (value - min) / (max - min);
            var text = Data_Show.show(Data_Show.showInt)(Data_Int.round(p * 100.0));
            var left = p * (v1 - Data_Int.toNumber(Data_String_CodePoints.length(text) * 10 | 0)) + 45.0;
            return {
                text: text,
                left: left
            };
        };
    };
    var render = function (self) {
        return React_Basic_DOM_Generated.span()({
            className: "col s4 m3 right input-field",
            style: React_Basic_DOM.css({
                height: "30px"
            }),
            children: [ React_Basic_DOM_Generated.i()({
                className: "material-icons prefix",
                children: [ React_Basic_DOM.text("zoom_in") ]
            }), React_Basic_DOM_Generated.span()({
                style: React_Basic_DOM.css({
                    position: "relative",
                    left: self.state.thumb.left,
                    fontSize: "smaller"
                }),
                children: [ React_Basic_DOM.text(self.state.thumb.text + "%") ]
            }), React_Basic_DOM_Generated.input()({
                id: "slider",
                type: "range",
                style: React_Basic_DOM.css({
                    top: "-15px"
                }),
                value: Data_Show.show(Data_Show.showInt)(self.props.value),
                min: Data_Show.show(Data_Show.showInt)(self.props.min),
                max: Data_Show.show(Data_Show.showInt)(self.props.max),
                onChange: React_Basic_Events.handler(React_Basic_DOM_Events.targetValue)(function (value) {
                    var value$prime = Data_Maybe.fromMaybe(0)(Control_Bind.bindFlipped(Data_Maybe.bindMaybe)(Data_Int.fromString)(value));
                    return function () {
                        return self.props.onChange(value$prime);
                    };
                })
            }) ]
        });
    };
    var initialState = {
        thumb: {
            left: 45.0,
            text: "0"
        }
    };
    var didUpdate = function (self) {
        return function (prev) {
            return function __do() {
                var v = xxx(self)();
                return Data_Monoid.guard(Effect.monoidEffect(Data_Monoid.monoidUnit))(self.state.thumb.left !== v.left)(self.setState(function (v1) {
                    var $10 = {};
                    for (var $11 in v1) {
                        if ({}.hasOwnProperty.call(v1, $11)) {
                            $10[$11] = v1[$11];
                        };
                    };
                    $10.thumb = v;
                    return $10;
                }))();
            };
        };
    };
    var didMount = function (self) {
        return function __do() {
            var v = xxx(self)();
            return self.setState(function (v1) {
                var $14 = {};
                for (var $15 in v1) {
                    if ({}.hasOwnProperty.call(v1, $15)) {
                        $14[$15] = v1[$15];
                    };
                };
                $14.thumb = v;
                return $14;
            })();
        };
    };
    return React_Basic.make()(component)({
        initialState: initialState,
        didMount: didMount,
        didUpdate: didUpdate,
        render: render
    });
})();
module.exports = {
    component: component,
    zoomSlider: zoomSlider
};
